/* Raul Diamonds (8 Oct 2026, final picks): collection filter bar and cards, product page metal / shape / spec cards. */
(function () {
  if (window.__rdRaul) return;
  window.__rdRaul = true;

  var d = document;
  function txt(el) { return (el && el.textContent || '').replace(/\s+/g, ' ').trim(); }
  function each(sel, fn, root) { Array.prototype.forEach.call((root || d).querySelectorAll(sel), fn); }
  function num(v) { var n = parseFloat(String(v).replace(',', '.')); return isNaN(n) ? null : n; }

  /* ---------------- Collection ---------------- */

  /* Card: picking a metal circle updates the "14K Yellow Gold / Oval" line */
  d.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('.rd-ci__metals input[type=radio]')) return;
    var card = t.closest('product-card'); if (!card) return;
    var l = card.querySelector('label[for="' + t.id + '"] .sr-only');
    var out = card.querySelector('[data-rd-cm]');
    if (l && out) out.textContent = txt(l);
  });

  /* Phone sort select (sticky bar) */
  d.addEventListener('change', function (e) {
    var s = e.target;
    if (!s || !s.matches || !s.matches('[data-rd-sort]')) return;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', s.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  /* Filter bar dropdowns: one open at a time, close on outside click or Escape */
  d.addEventListener('toggle', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-rd-dd]') || !t.open) return;
    each('[data-rd-dd][open]', function (o) { if (o !== t) o.open = false; });
  }, true);
  d.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-rd-dd]')) return;
    each('[data-rd-dd][open]', function (o) { o.open = false; });
  });
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    each('[data-rd-dd][open]', function (o) { o.open = false; var s = o.querySelector('summary'); if (s) s.focus(); });
  });

  /* ---------------- Product page ---------------- */
  function fieldset(cls) { return d.querySelector('.product-info fieldset.variant-picker__option.' + cls); }
  function picked(cls) {
    var f = fieldset(cls); if (!f) return null;
    var i = f.querySelector('input:checked');
    if (i) { var l = f.querySelector('label[for="' + i.id + '"]'); return l ? txt(l) : i.value; }
    var s = f.querySelector('select'); return s && s.selectedOptions[0] ? txt(s.selectedOptions[0]) : null;
  }
  function choose(cls, value) {
    var f = fieldset(cls); if (!f) return;
    var ls = f.querySelectorAll('label');
    for (var k = 0; k < ls.length; k++) {
      if (txt(ls[k]) === value) { var inp = d.getElementById(ls[k].getAttribute('for')); if (inp && !inp.checked) inp.click(); return; }
    }
    var s = f.querySelector('select');
    if (s) { for (var j = 0; j < s.options.length; j++) { if (txt(s.options[j]) === value) { s.selectedIndex = j; s.dispatchEvent(new Event('change', { bubbles: true })); return; } } }
  }
  var variantsCache = null;
  function variants() {
    if (variantsCache) return variantsCache;
    var el = d.querySelector('[data-rd-variants]');
    try { variantsCache = el ? JSON.parse(el.textContent) : []; } catch (e) { variantsCache = []; }
    return variantsCache;
  }

  function sync() {
    var m = picked('Metal'), ca = picked('Carat');
    each('[data-rd-metal]', function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-rd-metal') === m ? 'true' : 'false'); });
    if (m) each('[data-rd-metal-name]', function (el) { el.textContent = m; });
    if (ca) each('[data-rd-carat-name]', function (el) { el.textContent = ca; });
    var vs = variants();
    for (var k = 0; k < vs.length; k++) {
      var o = vs[k].o;
      if ((!m || o.indexOf(m) > -1) && (!ca || o.some(function (x) { return num(x) === num(ca); }))) {
        each('[data-rd-sku]', function (el) { el.textContent = vs[k].s ? 'SKU: ' + vs[k].s : ''; });
        break;
      }
    }
  }

  d.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest) return;
    var mb = t.closest('[data-rd-metal]');
    if (mb) { choose('Metal', mb.getAttribute('data-rd-metal')); setTimeout(sync, 60); return; }
    var tb = t.closest('[data-rd-tab]');
    if (tb) {
      var box = tb.closest('[data-rd-know]'); if (!box) return;
      each('[data-rd-tab]', function (b) { b.setAttribute('aria-selected', b === tb ? 'true' : 'false'); }, box);
      each('[data-rd-pane]', function (p) { p.hidden = p.getAttribute('data-rd-pane') !== tb.getAttribute('data-rd-tab'); }, box);
    }
  });
  d.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('.product-info')) setTimeout(sync, 60); });
  d.addEventListener('variant:change', function () { setTimeout(sync, 80); });

  /* Shape circles keep the chosen metal and carat when they open the other shape */
  var cache = {};
  function load(h) {
    if (!cache[h]) cache[h] = fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products/' + h + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); });
    return cache[h];
  }
  d.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-rd-shape-link]') : null; if (!a) return;
    if (a.getAttribute('aria-current') === 'true') { e.preventDefault(); return; }
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    var href = a.getAttribute('href'), metal = picked('Metal'), carat = picked('Carat'), done = false;
    function go(u) { if (done) return; done = true; window.location.href = u; }
    a.setAttribute('aria-busy', 'true');
    setTimeout(function () { go(href); }, 1500);
    load(a.getAttribute('data-rd-shape-link')).then(function (p) {
      var best = null, score = -1, c = num(carat);
      (p.variants || []).forEach(function (v) {
        var o = v.options || [], s = 0;
        if (metal && o.indexOf(metal) > -1) s += 2;
        if (c !== null && o.some(function (x) { return num(x) === c; })) s += 1;
        if (s > score) { best = v; score = s; }
      });
      go(best && score >= 2 ? href + (href.indexOf('?') > -1 ? '&' : '?') + 'variant=' + best.id : href);
    }).catch(function () { go(href); });
  });
  d.addEventListener('pointerover', function (e) {
    var a = e.target.closest ? e.target.closest('[data-rd-shape-link]') : null;
    if (a) load(a.getAttribute('data-rd-shape-link')).catch(function () {});
  });


  /* ---------- Category / style rows: arrows when the row scrolls (desktop) ---------- */
  function ertArrows() {
    each('.rdx-ert', function (nav) {
      var row = nav.querySelector('.rdx-ert__row'); if (!row || nav.querySelector('.rdx-ert__nav')) return;
      var mk = function (dir) {
        var b = d.createElement('button'); b.type = 'button'; b.className = 'rdx-ert__nav rdx-ert__nav--' + (dir < 0 ? 'prev' : 'next');
        b.setAttribute('aria-label', dir < 0 ? 'Scroll left' : 'Scroll right');
        b.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="' + (dir < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>';
        b.addEventListener('click', function () { row.scrollBy({ left: dir * row.clientWidth * 0.8, behavior: 'smooth' }); });
        nav.appendChild(b); return b;
      };
      var p = mk(-1), n = mk(1);
      var upd = function () { p.disabled = row.scrollLeft < 4; n.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4; };
      row.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
      window.addEventListener('resize', upd); upd();
      var cur = row.querySelector('.is-on'); if (cur && cur.offsetLeft > row.clientWidth * 0.6) row.scrollLeft = cur.offsetLeft - 40;
      upd();
    });
  }


  /* ---------- Product page: % off pill next to the price, IGI seal on the gallery ---------- */
  function pdpPrice() {
    var pb = d.querySelector('.product-info [data-block-type="price"] .v-stack');
    var bl = d.querySelector('.product-info [data-block-type="badges"] badge-list');
    if (pb && bl && bl.parentElement !== pb) { pb.classList.add('rd-pricerow'); pb.appendChild(bl); }
    var tpl = d.querySelector('template[data-rd-igi-gal]');
    var gal = d.querySelector('.product-gallery');
    if (tpl && gal && !gal.querySelector('.rd-galigi')) {
      var b = tpl.content.firstElementChild.cloneNode(true);
      b.classList.add('rd-galigi'); b.setAttribute('aria-hidden', 'true');
      var im = b.querySelector('img'); if (im) im.removeAttribute('loading');
      gal.appendChild(b);
    }
  }
  d.addEventListener('variant:change', function () { setTimeout(pdpPrice, 120); });

  /* Oct 9 2026 audit: phone filter bar shows only after the top Filter row scrolls away; PDP field labels and notes */
  function mbar() {
    var b = d.querySelector('.rd-mbar'); if (!b) return;
    var t = d.querySelector('.rd-ctm');
    var on = !t || !t.offsetParent || t.getBoundingClientRect().bottom < 0;
    b.classList.toggle('rd-mbar--on', on);
  }
  window.addEventListener('scroll', mbar, { passive: true });
  window.addEventListener('resize', mbar);
  function pdpFields() {
    each('.rd-ring-size-note', function (n) { if (n.getAttribute('data-rd-n')) return; n.setAttribute('data-rd-n', '1'); n.textContent = 'Not sure of the size? One free resize within 60 days.'; });
    each('.rd-length-label', function (l) { l.textContent = 'Length'; });
    var h = d.querySelector('.product-info h1, h1.product-title'); var tt = h ? txt(h) : d.title;
    each('.product-gallery img:not([alt]), .product-gallery__media img:not([alt])', function (i) { i.setAttribute('alt', tt + ' video'); });
  }
  function init() { sync(); ertArrows(); pdpPrice(); mbar(); pdpFields(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', sync);
})();
